import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoItsFor() {
  return <Section className="bg-white" data-id="element-199">
      <FadeIn data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2D2A26] text-center mb-12" data-id="element-201">
          ¿Para quién es?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-202">
          <div className="bg-[#5BBFB5]/10 p-8 rounded-2xl border border-[#5BBFB5]/20" data-id="element-203">
            <h3 className="text-xl font-bold text-[#2D2A26] mb-6 flex items-center gap-2" data-id="element-204">
              <CheckCircle2 className="text-[#5BBFB5]" data-id="element-205" />
              Sí es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-206">
              <li className="flex items-start gap-3" data-id="element-207">
                <span className="w-1.5 h-1.5 bg-[#5BBFB5] rounded-full mt-2.5 flex-shrink-0" data-id="element-208"></span>
                <span className="text-[#2D2A26]/80" data-id="element-209">
                  Vives en apartamento y el olor se siente más rápido
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-210">
                <span className="w-1.5 h-1.5 bg-[#5BBFB5] rounded-full mt-2.5 flex-shrink-0" data-id="element-211"></span>
                <span className="text-[#2D2A26]/80" data-id="element-212">
                  Tienes perro, gato o ambos
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-213">
                <span className="w-1.5 h-1.5 bg-[#5BBFB5] rounded-full mt-2.5 flex-shrink-0" data-id="element-214"></span>
                <span className="text-[#2D2A26]/80" data-id="element-215">
                  Recibes visitas o simplemente quieres paz mental
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-216">
                <span className="w-1.5 h-1.5 bg-[#5BBFB5] rounded-full mt-2.5 flex-shrink-0" data-id="element-217"></span>
                <span className="text-[#2D2A26]/80" data-id="element-218">
                  Quieres una rutina corta y clara, no un proyecto infinito
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-2xl border border-gray-200" data-id="element-219">
            <h3 className="text-xl font-bold text-[#2D2A26] mb-6 flex items-center gap-2" data-id="element-220">
              <XCircle className="text-gray-400" data-id="element-221" />
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-222">
              <li className="flex items-start gap-3" data-id="element-223">
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-224"></span>
                <span className="text-[#2D2A26]/80" data-id="element-225">
                  Buscas cero esfuerzo (requiere acción)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-226">
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-227"></span>
                <span className="text-[#2D2A26]/80" data-id="element-228">
                  Tu mascota tiene síntomas de salud (eso es veterinario)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-229">
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-230"></span>
                <span className="text-[#2D2A26]/80" data-id="element-231">
                  No estás dispuesto a hacer 12 minutos al día por una semana
                </span>
              </li>
            </ul>
          </div>
        </div>
      </FadeIn>
    </Section>;
}